import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Per-page SEO metadata.
 *
 * Sets <title>, <meta description>, canonical URL and the html lang attribute.
 * The canonical is built from the current origin so it works in both preview
 * and production without config changes.
 */
export default function Seo({ title, description, path = "/", noIndex = false }) {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const canonical = origin ? `${origin}${path}` : path;
  return (
    <Helmet>
      <html lang="es" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      {noIndex && <meta name="robots" content="noindex,nofollow" />}
    </Helmet>
  );
}
